<template>
  <div class="custom-swiper-container">
    <swiper class="custom-swiper-wrapper" :options="swiperOption" ref="mySwiper" v-if="list.length>0" @slide-change="f1">
      <swiper-slide class="custom-swiper-slide" v-for="item in list" :key="item.cameraId">
        <div class="swiper-content">
          <!--          <video class="video-tag" :ref="item.cameraId" :data-name="item.cameraName" ></video>-->
          <video class="video-tag" :ref="item.cameraId" :data-name="item.cameraName" autoplay muted></video>
        </div>
      </swiper-slide>
    </swiper>
    <div class="swiper-button-prev"></div><!--左箭头。如果放置在swiper-container外面，需要自定义样式。-->
    <div class="swiper-button-next"></div><!--右箭头。如果放置在swiper-container外面，需要自定义样式。-->
    <!-- Optional controls -->
    <div class="swiper-pagination swiper-pagination-bullets"  slot="pagination"></div>
  </div>
</template>

<script>
/*
* 注意npm的版本必须是下列版本:(升级或修改版本对应请查找npm的swiper插件包文档或者swiper官网)
* "swiper": "^4.5.1",
* "vue-awesome-swiper": "^3.1.3",
* */
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'

import Hls from 'hls.js'

export default {
  name: 'VideoSwiper',
  components: { swiper, swiperSlide },
  data () {
    return {
      hls: null,
      top:[],
      bom:[],
      swActiveIndex:0,
      swiperOption: {
        slidesPerView: 2, // 一行显示2个
        slidesPerColumn: 2, // 显示2行
        slidesPerColumnFill: 'row',
        observer: true,
        autoplay: {
          delay: 30000, //10秒切换一次
          disableOnInteraction: false
        },
        observeParents: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: '.swiper-pagination',
          bulletClass : 'swiper-bullet',
          type: 'bullets',
          bulletElement: 'li',
          clickable: true
        }
      }
    }
  },
  props: {
    list: {
      type: Array,
      default: () => (new Array(4).fill({}))
    },
    isCutDept : false // 切换食堂
  },
  computed: {
    swiper () {
      return this.$refs.mySwiper.swiper
    }
  },
  watch: {
    list: {
      handler(cur) {
        console.log('$$$$$$播放列表数据$$$$$$::', cur)
        this.$nextTick(() => {
          // this.init()
          this.top=this.list.slice(0,this.list.length/2)
          this.bom=this.list.slice(this.list.length/2,this.list.length)
          this.attach(0)
        })
      }
    },
    // 切换食堂，需要将上一次的视频流删除
    isCutDept:{
      deep:true,
      handler(){
        console.log('department cut:',this.isCutDept)
        if(this.isCutDept){
          this.hlsDestory()
          this.$emit('childChangeDept',false)
        }
      }
    }
  },
  activated() {
    this.$nextTick(() => {
      this.attach(0)
    })
  },
  // deactivated() {
  //   for (let i = 0; i < this.list.length; i++) {
  //     this.list[i].hls.destroy()
  //   }
  // },
  methods: {
    f1(){
      this.hlsDestory()
      this.attach(this.$refs.mySwiper.swiper.activeIndex)
    },
    attach (page) {
      for (let i = page; i < page+2; i++) {
        if (this.top[i].cameraId && Hls.isSupported()) {
          this.$request.cameraStreamGet({cameraId: this.top[i].cameraId}).then(res => {
            this.top[i].hls = new Hls()
            this.top[i].hlsUrl=res.streamUrl
            this.top[i].hls.loadSource(this.top[i].hlsUrl)
            this.top[i].hls.attachMedia(this.$refs[this.top[i].cameraId][0])
          }).catch(e => {
            console.error(e)
          })

        }
        if (this.bom[i].cameraId && Hls.isSupported()) {
          this.$request.cameraStreamGet({cameraId: this.bom[i].cameraId}).then(res => {
            this.bom[i].hls = new Hls()
            this.bom[i].hlsUrl=res.streamUrl
            this.bom[i].hls.loadSource(this.bom[i].hlsUrl)
            this.bom[i].hls.attachMedia(this.$refs[this.bom[i].cameraId][0])
          }).catch(e => {
            console.error(e)
          })

        }
      }
    },
    hlsDestory(){
      console.error('begin destory',this.list)
      for (let i = 0; i < this.list.length; i++) {
        if (this.list[i].cameraId && this.list[i].hlsUrl && Hls.isSupported()) {
          this.list[i].hls.destroy()
          console.error('begin singl destory',this.list[i])
        }
      }
    },
    init () {
      for (let i = 0; i < this.list.length; i++) {
        if (this.list[i].cameraId && this.list[i].hlsUrl) {
          if (Hls.isSupported()) {
            this.list[i].hls.on(Hls.Events.MANIFEST_PARSED, () => {
              this.$refs[this.list[i].cameraId][0].play()
            })
          }
        }
      }
    },
    /**
     * @description: 播放
     * @author: linwen linwen@fjxhx.com
     * @createDate: 2020-12-22 17:17
     * @param: id video标签的id
     * @param: url 播放链接
     */
    play (id, src) {
      console.error('id', id)
      console.error('src', src)
    }
  }
}
</script>

<style scoped lang="less">
.custom-swiper-container {
  width: 1225px;
  height: 960px;
  position: relative;
  .custom-swiper-wrapper {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    box-sizing: content-box;
    .custom-swiper-slide {
      height: 478px;
      .swiper-content {
        height: 470px;
        box-sizing: border-box;
        margin: 5px;
        padding: 1px;
        box-shadow: 0px 0px 1px #000000;
        background-color: rgba(0,0,0,.6);
        .video-tag {
          width: 100%;
          height: 100%;
          object-fit: fill;
        }
        &:hover {
          box-shadow: 0px 0px 8px #000000;
        }
      }
    }
  }
  & /deep/ .swiper-pagination {
    &.swiper-pagination-bullets {
      width: 100%;
      left: 0px;
      bottom: -14px;
    }

    .swiper-bullet {
      margin: 0px 4px;
      width: 12px;
      height: 12px;
      display: inline-block;
      border-radius: 100%;
      background: #000;
      opacity: .5;
    }

    .swiper-pagination-bullet-active {
      opacity: 1;
      background: #007aff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/VideoSwiper/VideoSwiper.vue